exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-layer{z-index:11;text-align:left}.title-layer .video-title{position:absolute;top:0;left:0;right:0;padding:16px 20px;line-height:32px;font-size:14px;background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.7)),to(transparent));background-image:linear-gradient(180deg,rgba(0,0,0,.7),transparent)}.fullscreen .title-layer .video-title{font-size:16px;font-weight:700}", ""]);

// exports
